import { Divider, Grid2 as Grid, Typography } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { boardOptions, stateOptions } from "@shared/options";
import { UsersAutocomplete, AmigobotDoctorsAutocomplete } from "@shared/components/AutocompleteFields";

export function PrescriberForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <UsersAutocomplete
          name="user"
          label={translate("prescriber_admin.fields.user")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="board_code"
          label={translate("prescriber_admin.fields.board_code")}
          options={boardOptions}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="board_number"
          label={translate("prescriber_admin.fields.board_number")}
          mask="number"
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Autocomplete
          name="board_state"
          label={translate("prescriber_admin.fields.board_state")}
          valueField="value"
          labelField="label"
          options={stateOptions}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("prescriber_admin.titles.amigobot_integration")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AmigobotDoctorsAutocomplete
          name="amigobot_doctor_id"
          label={translate("prescriber_admin.fields.amigobot_doctor_id")}
        />
      </Grid>
    </Grid>
  );
}
